import React from 'react';
import clx from "classnames";
import { FiBell, FiCalendar, FiLogOut, FiMessageSquare, FiPhone, FiSearch, FiSettings, FiUsers } from 'react-icons/fi'
import messengerStore from '../../../../stores/useMessenger'
import Users from './users' 
import Phones from './phones' 
import Searches from './searches' 
import Calendars from './calendars' 
import Contacts from './contacts' 
import Notifications from './notifications' 
import Settings from './settings' 
import supportStore from '../../../../stores/useSupport';

export const Sidebar = ({mobile}) => {
    const [tab, setTab] = React.useState('users');
    const {detail} = supportStore(state=>state)
  
    return (
      <React.Fragment>
         {/** SIDEBAR **/}
         <div className={clx(
          !mobile ? 'hidden lg:flex' : 'flex',
          'sidebar', detail?'col-span-3':'col-span-4' )} >
  
        {/** LEFT SIDEBAR **/}
        <div className="flex flex-col justify-between items-center 
          primarydark text-white
          dark:bg-[#12171d] bg-gray-100 p-3">
          
            <div className="dark:bg-zinc-700- bg-gray-50- rounded-md h-14 w-14 p-1 flex items-center justify-center">
              <img src="/images/demo/logo-square.png" className="rounded-lg hidden" />
            </div>
  
  
            <div className="flex flex-col">
              <div className="flex flex-col items-center text-gray-400">
                <div
                  className={clx('p-4', {'bg-blue-100 text-blue-500 rounded-lg': tab=='users' })} 
                  onClick={()=>setTab('users')}
                >
                  <FiMessageSquare size={24} className="cursor-pointer" />
                </div>
                <div
                  onClick={()=>setTab('phones')}
                  className={clx('p-4', {'bg-green-200 text-green-500 rounded-lg': tab=='phones'})} 
                >
                  <FiPhone size={24} className="cursor-pointer" />
                </div>
                <div
                  onClick={()=>setTab('search')}
                  className={clx('p-4', {'bg-purple-100 text-purple-400 rounded-lg': tab=='search'})} 
                >
                  <FiSearch size={24} className="cursor-pointer" />
                </div>
                <div
                  onClick={()=>setTab('calendar')}
                  className={clx('p-4', {'bg-orange-100 text-orange-400 rounded-lg': tab=='calendar'})} 
                >
                  <FiCalendar size={24} className="cursor-pointer" />
                </div>
                <div
                  onClick={()=>setTab('index')}
                  className={clx('p-4', {'bg-red-100 text-red-400 rounded-lg': tab=='index'})} 
                >
                  <FiUsers size={24} className="cursor-pointer" />
                </div>
              </div>
            </div>
  
  
            <div className="flex flex-col gap-6 items-center text-gray-400">
              <div onClick={()=>setTab('notifications')} className="relative cursor-pointer">
                <FiBell size={24} />
              <div className="badge bg-red-500 p-1 rounded-full absolute -right-1 -top-1"></div>
          </div>
  
          <FiLogOut size={24} className="rotate-180 cursor-pointer" />
  
          <div onClick={()=>setTab('settings')} className="flex flex-col items-center cursor-pointer" >
          <FiSettings size={24} className="text-zinc-400" />
          <p className="text-zinc-400 text-sm">Settings</p>
        </div>
  
        </div>
        </div>
  
        {/** USER MESSAGES **/}
        <div
          className="messages bg-gray-50 dark:bg-[#1e2126] dark:text-white w-full relative overflow-y-auto h-screen"
        >
             {tab=='users' && <Users /> }
             {tab=='phones' && <Phones /> }
             {tab=='search' && <Searches /> }
             {tab=='calendar' && <Calendars /> }
             {tab=='index' && <Contacts /> }
             {tab=='notifications' && <Notifications /> }
             {tab=='settings' && <Settings /> }
  
        </div>
  
  
        </div>
      </React.Fragment>
    )
}

export default Sidebar;
   